module.exports = __webpack_public_path__ + "img/location.c07de916.svg";